<template>
  <div id="ListActiveDetail2" class="well" style="padding: 0 1em">
    <div>
      <button
        href="#"
        @click.prevent="close()"
        class="btn btn-outline-secondary"
        type="button"
        style="font-size: 14px"
      >
        回活動列表
      </button>
    </div>

    <table v-if="inputData != null" style="text-align: left" class="table">
      <thead>
        <tr v-if="inputData[0].activeName != null">
          <th>
            <h3>{{ inputData[0].activeName }}</h3>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div>
              <span>本活動小組長/手機：</span
              ><span>{{
                inputData[0].name + "/" + inputData[0].cellPhone
              }}</span>
            </div>
          </td>
        </tr>
        <tr class="table-success">
          <td>
            <div>
              <span>活動類型：</span><span>{{ inputData[0].typeName }}:{{ inputData[0].activeClass }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div>
              <span>本次活動參與人數：</span
              ><span>{{ inputData[0].activeNumber }}</span>
            </div>
          </td>
        </tr>
        <tr class="table-success">
          <td>
            <div>
              <span>活動時間起迄：</span
              ><span
                >{{ inputData[0].sActiveTime }}&nbsp;~&nbsp;{{
                  inputData[0].eActiveTime
                }}</span
              >
            </div>
          </td>
        </tr>
        <tr v-if="!ForumEnable" align="left">
          <td>
            <span class="red_star">＊</span>交通方式:{{ inputData[0].orderTID }}
            <div>
              <b-form-radio
                v-model="inputData[0].orderTID"
                v-for="(item, itIdx) in options4"
                :key="'C' + itIdx"
                :value="item.value"
                :disabled="!inputData[0].tidsArray.includes(item.value)"
                >{{ item.text }}</b-form-radio
              >
            </div>
          </td>
        </tr>

        <tr v-if="ClassEnable" class="table-success">
          <td>
            <div>
              <span>班級數/人數：</span
              >{{ inputData[0].classNumber + "/" + inputData[0].studentNumber }}
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div>
              <span>集合時間(統一出發)：</span
              ><span>{{ inputData[0].schoolGatherTime }}</span
              ><br />
              <span>集合地點(統一出發)：</span
              ><span>{{ inputData[0].schoolGatherPlace }}</span
              ><br />
              <span>集合時間(自行前往)：</span
              ><span>{{ inputData[0].goBySelfGatherTime }}</span
              ><br />
              <span>集合地點(自行前往)：</span
              ><span>{{ inputData[0].goBySelfGatherPlace }}</span
              ><br />
            </div>
          </td>
        </tr>
        <tr class="table-success">
          <td>
            <div>
              <span class="red_star">＊</span>經費來源

              <div
                class="form-check form-check-inline"
                v-for="(option, index) in budgetOptions"
                :key="index"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="budgetArray"
                  :value="option.value"
                  :id="'inlineCheckbox' + option.value"
                />
                <label
                  :for="'inlineCheckbox' + option.value"
                  class="form-check-label"
                  >{{ option.label }}</label
                >
              </div>
            </div>
          </td>
        </tr>
        <template v-if="ClassEnable">
          <tr class="table-success">
            <td>
              <div>
                <span class="red_star">＊</span>宣導班級

                <div
                  v-for="(data, i) in selectedClassesFun"
                  :key="i"
                  :index="i"
                >
                  宣導班級: {{ data.className }}
                  <!-- <input
                    type="checkbox"
                    :id="'checkbox_' + index"
                    v-model="selectedClasses"
                    :value="data.clid"
                  /> -->

                  <!-- 指定科系: {{ data.series }} -->
                  <br />
                </div>
              </div>
            </td>
          </tr>
        </template>

        <tr class="table-success">
          <td>
            <div>
              <span>校園地圖：</span
              ><span v-if="mode">
                <a
                  :href="'./WebApi/Common/GetDocumentFile/' + file[0].RowId"
                  target="_blank"
                  :title="file[0].name"
                >
                  <img
                    src="@/assets/images/disk.png"
                    style="width: 1.5em; height: 1.5em"
                  />
                </a>
                {{ file[0] ? file[0].name : "" }}</span
              >
              <span v-else> 無 </span>
            </div>
          </td>
        </tr>
        <tr >
          <td>
            <div>
              <span>備註：</span><span>{{ inputData[0].remark }}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
import * as tools from "../tool";
export default {
  name: "ListActiveDetail2",
  props: ["aid", "sn"],
  data() {
    return {
      index:0,
      selectedOptions: [],
      budgetArray: [],
      ClassEnable:false,
      ForumEnable: false,
      selectedClasses: true,
      options2: [
        { value: 4, text: "不分群" },
        { value: 5, text: "電機與電子群" },
        { value: 6, text: "機械群" },
        { value: 7, text: "動力機械群" },
        { value: 8, text: "化工群" },
        { value: 9, text: "商管群" },
        { value: 10, text: "土木與建築群" },
        { value: 11, text: "設計群" },
        { value: 12, text: "農業群" },
        { value: 13, text: "產學班" },
      ],

      options4: [
        { key: "1", value: "A4", text: "公務車4人座" },
        { key: "2", value: "B6", text: "公務車6人座" },
        { key: "3", value: "C8", text: "公務車8人座" },
        { key: "4", value: "D3", text: "租賃車3人座" },
        { key: "5", value: "E8", text: "租賃車8人座" },
        { key: "6", value: "F18", text: "遊覽車18人座" },
        { key: "7", value: "G40", text: "遊覽車40人座" },
        { key: "8", value: "H1", text: "自行前往(大眾運輸)" },
        { key: "9", value: "I1", text: "自行開車(車牌)" },
      ],
      options6: [
        { value: "999", text: "不指定", disabled: false  },
        { value: "11", text: "電機工程系", disabled: false },
        { value: "14", text: "電子工程系", disabled: false },
        { value: "40", text: "資訊工程系", disabled: false },
        {
          value: "47",
          text: "人工智慧應用工程系",
          disabled: false

        },
        { value: "22", text: "機械工程系", disabled: false },
        {
          value: "25",
          text: "冷凍空調與能源系",
          disabled: false
        },
        {
          value: "19",
          text: "化工與材料工程系",
          disabled: false
        },
        {
          value: "46",
          text: "智慧自動化工程系",
          disabled: false
        },
        { value: "27", text: "企業管理系", disabled: false },
        {
          value: "33",
          text: "健康產業科技研發與管理系",
          disabled: false
        },
        {
          value: "16",
          text: "工業工程與管理系",
          disabled: false
        },
        { value: "26", text: "流通管理系", disabled: false },
        { value: "38", text: "資訊管理系", disabled: false },
        {
          value: "32",
          text: "文化創意事業系",
          disabled: false
        },
        { value: "35", text: "應用英語系", disabled: false },
        { value: "24", text: "景觀系", disabled: false },
      ],
      budgetOptions: [
        { value: 1, label: "高教經費" },
        { value: 2, label: "選才計畫" },
        { value: 3, label: "技高經費" },
        { value: 4, label: "各系經費" },
        { value: 5, label: "其他" },
      ],
      id: null,
      dptcd: null,
      mode: false,
      file: [{ name: "", RowId: "" }],
      total: 0,
      total2: 0,
      isIE: false,
      inputData: null,
      queryInfo: {
        budgetArray: [],
        aid: null,
        orderTID: null,
        dptcd: null,
        clidsArray: [],
        updateUser: null,
        gid: null,
      },
      inputData2: null,

      selectedRowIndex: 0,
      currentPage: 1,
      cid: "",
      pageSize: 10,
      queryInfo: {
        sysId: 0,
      },
    };
  },
  computed: {
    selectedClassesFun() {
      const inputDataCopy = this.inputData2.slice(); // 創建一個新的陣列副本

        const filteredData = inputDataCopy.filter((item) =>
          this.inputData[0].clidsArray.includes(item.clid.toString())
        );

        const selectedClassesData = filteredData.map((inputItem) => {
          if (inputItem && inputItem.depIDString !== undefined) {

            const matchingOption = this.options6.find(
              (option) => option.value == inputItem.depIDString
            );


            if (matchingOption) {
              return {
                series: matchingOption.text, // 對應到系所名稱
                className: inputItem.className, // 對應到班級名稱
                clid: inputItem.clid,
              };
            } else {
              return null;
            }
          } else {
            return null;
          }
        });

      // 過濾掉可能為 null 的值
      const result = selectedClassesData.filter((data) => data !== null);

      return result.length > 0 ? result : [{ series: "", className: "" }];
    },
    filteredDocs: function () {
      let data = [];

      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },
  },
  methods: {
    checkClassEnable() {
      if (
        this.$props.sn == 14 ||
        this.$props.sn == 15 ||
        this.$props.sn == 16
      ) {
        this.ClassEnable = true;
      }
      if (this.$props.sn == 7)
      {

        this.ForumEnable=true;
      }
    },
    getDepName() {
      let vm = this;
      const inputDataCopy = this.inputData2.slice(); // 創建一個新的陣列副本
      // 迭代 inputData2
    //  console.log("vm.inputData2", vm.inputData2);
      inputDataCopy.forEach((item) => {
        // 找到對應的 options6
        const matchedOption = vm.options6.find(
          (option) => option.value === item.depIDString
        );

        // 如果找到對應的 option，且 depIDStringArray 中還未包含該值，則加入
        if (matchedOption) {
          item.depIDStringArray = matchedOption.text;
        }
      });
    },

    getActiveDetail2() {
      let vm = this;

      this.$http
        .get(
          "./WebApi/HighSchoolEnrolling/GetActiveDetail2/".concat(
            vm.dptcd + "/" + vm.$props.aid + "/" + vm.id + "/" + vm.ClassEnable
          )
        )
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data;

           // console.log("vm.inputData", vm.inputData);
            vm.total = vm.inputData.length;
            vm.inputData[0].tidsArray = response.data[0].tids.split(",");
            vm.budgetArray = vm.inputData[0].budget.split(",");
            vm.inputData[0].clidsArray = vm.inputData[0].clids.split(",");

            vm.inputData[0].activeClass="";
            if (vm.inputData[0].studentGroup != 0)
            {
              const matchedOption2 = vm.options2.find(
                (option) => option.value === vm.inputData[0].studentGroup
              );
              if (matchedOption2)
              {

                vm.inputData[0].activeClass=matchedOption2.text ;
              }

            }


            if (
              response.data[0].campusMap == true &&
              response.data[0].attachInfoString != null
            ) {
              this.mode = true;
              const jsonArr = JSON.parse(response.data[0].attachInfoString);
              if (!tools.empty(jsonArr)) {
                this.file[0].name = jsonArr.FileNm;
                this.file[0].RowId = jsonArr.RowId;
              }
            }
          }
        })
        .catch(function (error) {
          tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
    getClassLimitList(aid) {
      let vm = this;
      let Selected =true;
      this.$http
        .get("./WebApi/HighSchoolEnrolling/GetClassLimitList/".concat(aid + "/" + Selected))
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData2 = response.data;

            if (!tools.empty(vm.inputData2)) {
              vm.getDepName();
              console.log("vm.inputData2", vm.inputData2);
            }
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
    close() {
      this.$emit("hideModal");
    },
  },
  created() {
    console.log("======created ListActiveDetail2 =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;

      let vm = this;

if (vm.$store.getters.getAllstate.inputData != null) {
  vm.id = vm.$store.getters.getAllstate.inputData.usrData.id;
  vm.dptcd = vm.$store.getters.getAllstate.inputData.usrData.dptcd;
} else {
  vm.id = vm.$store.getters.getAllstate.user.id;
  vm.dptcd = vm.$store.getters.getAllstate.user.dptcd;
}

    vm.checkClassEnable();
    if (vm.ClassEnable) {
      vm.getClassLimitList(vm.$props.aid);
    }
    vm.getActiveDetail2();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
